import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import * as styles from './ProfileImage.module.css';

const ProfileImage = ({ image, isSpark }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (isSpark) {
      setAnimate(true);
    }
  }, [isSpark]);

  return (
    <div className={styles.imageContainer}>
      {image?.gatsbyImageData ? (
        <GatsbyImage
          alt={image.title || ''}
          image={image.gatsbyImageData}
          className={[animate && styles.spark].join(' ')}
          style={{ height: `${isSpark ? '100%' : 'auto'}` }}
        />
      ) : (
        image?.file?.url && (
          <img
            src={image?.file?.url}
            alt={image.title || ''}
            draggable="false"
            className={[animate && styles.spark].join(' ')}
            style={{ height: `${isSpark ? '100%' : 'auto'}` }}
          />
        )
      )}
      )}
    </div>
  );
};

ProfileImage.propTypes = {
  image: PropTypes.object.isRequired,
};

export default ProfileImage;
